import script from "./PasswordChange.vue?vue&type=script&setup=true&lang=js"
export * from "./PasswordChange.vue?vue&type=script&setup=true&lang=js"

import "./PasswordChange.vue?vue&type=style&index=0&id=5728da86&lang=css"

const __exports__ = script;

export default __exports__